export const decorateFollow = relation => {
	return {
		followId: relation.id,
		followType: 'Workspace',
		workspace: relation,
	};
};

export const decorateExistingFollow = ({ followId }) => {
	return { followId, followType: 'Workspace' };
};
